import { useEffect } from 'react';
import { onCLS, onINP, onFCP, onLCP, onTTFB } from 'web-vitals';

interface PerformanceMetric {
  name: string;
  value: number;
  rating: 'good' | 'needs-improvement' | 'poor';
}

/**
 * Hook to monitor Core Web Vitals and send to analytics
 */
export function usePerformanceMonitor(enabled: boolean = true) {
  useEffect(() => {
    if (!enabled || !import.meta.env.PROD) return;
    
    // Skip in Lovable preview to avoid CORS issues
    if (typeof location !== 'undefined' && location.hostname.endsWith('lovable.app')) return;

    const sendToAnalytics = (metric: PerformanceMetric) => {
      // Log to console in development only
      if (import.meta.env.DEV) {
        console.log(`[Performance] ${metric.name}:`, metric.value, `(${metric.rating})`);
      }

      // Send to backend for tracking
      fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/log-performance`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY}`,
        },
        body: JSON.stringify({
          metric: metric.name,
          value: metric.value,
          rating: metric.rating,
          url: window.location.pathname,
          timestamp: new Date().toISOString(),
        }),
      }).catch(console.error);
    };

    // Monitor Core Web Vitals
    onCLS(sendToAnalytics);
    onINP(sendToAnalytics);
    onFCP(sendToAnalytics);
    onLCP(sendToAnalytics);
    onTTFB(sendToAnalytics);
  }, [enabled]);
}
